// extracted by mini-css-extract-plugin
module.exports = {"mindHint":"index_mindHint__RtM6z","linearText":"index_linearText__g_JR2","linear-text-animation":"index_linear-text-animation__0ETJg"};